import React, { Component } from 'react';

class InstallmentGuidelines extends Component {

    render(){
        return(
            <div className={this.props.installmentAlertType} id="billingGuidelines">
                <h4>Installment Guidelines </h4>
                <p>
                    If you choose to pay using installments, you cannot take more than four months to
                    pay and your installment amount cannot be less than $75.
                </p>
            </div>
        )
    }

}

export default InstallmentGuidelines;